var exports = {
  "ai": "number__isMsaU",
  "Gk": "branchComparison__kq1Maz",
  "at": "branchName__yCF91M",
  "wd": "iconOpen__Le4Yb3",
  "kX": "iconClosed__jhtLZv",
  "W8": "iconMerged__IFlL4V",
  "bU": "iconMuted__YTDDsL",
  "qp": "iconAccent__NKnlSm",
};

module.exports = exports;
